const mod = require('react-display-name')

module.exports = mod
